<script lang="ts" setup>
import CheckIcon from '../../assets/svg/check.svg'
import ErrorIcon from '../../assets/svg/error.svg'
import { ref } from 'vue'

const props = defineProps<{
  createOrder: (isSuccess: boolean) => Promise<any>
}>()

const emit = defineEmits<{
  (e: 'submit'): void
  (e: 'error', value: any): void
  (e: 'completed'): void
  (e: 'failed', value: any): void
}>()

const loading = ref(false)

const handleSuccess = async () => {
  if (loading.value) return
  loading.value = true
  emit('submit')

  try {
    await props.createOrder(true)
    emit('completed')
  } catch (error) {
    emit('error', error)
  } finally {
    loading.value = false
  }
}

const handleFailed = async () => {
  if (loading.value) return
  loading.value = true
  emit('submit')

  try {
    await props.createOrder(false)
    emit('failed', { message: 'sandbox_payment_failed' })
  } catch (error) {
    emit('error', error)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div :class="$style.sandboxContainer">
    <div v-if="!loading" :class="$style.sandboxContent">
      <div :class="$style.sandboxCard" @click="handleSuccess">
        <div :class="$style.cardLeft">
          <CheckIcon :class="[$style.cardIcon, $style.successIcon]"></CheckIcon>

          <span :class="$style.cardText">支付成功页面</span>
        </div>
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
          <path d="M1 1L7 7L1 13" stroke="#C0C4CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <div :class="$style.sandboxCard" @click="handleFailed">
        <div :class="$style.cardLeft">
          <ErrorIcon :class="[$style.cardIcon, $style.failedIcon]"></ErrorIcon>

          <span :class="$style.cardText">支付失败页面</span>
        </div>
        <svg :class="$style.cardArrow" width="8" height="14" viewBox="0 0 8 14" fill="none">
          <path d="M1 1L7 7L1 13" stroke="#C0C4CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>

    <div v-else :class="$style.loadingContainer">
      <div :class="$style.loadingSpinner"></div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sandbox-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.sandbox-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sandbox-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 20px;
  background: #f8f9fb;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9f9f9;
  }

  &:active {
    background-color: #f0f0f0;
  }
}

.card-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  width: 24px;
  height: 24px;

  &.success-icon {
    color: #48cf6c;
  }

  &.failed-icon {
    color: #f94e4e;
  }
}

.card-text {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 24px;
}

.card-arrow {
  flex-shrink: 0;
}

.loadingContainer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);

  .loadingSpinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(78, 90, 240, 0.4);
    border-top-color: #4e5af0;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
